import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("norea_token");
    const u = localStorage.getItem("norea_user");
    if (token && u) {
      try {
        setUser(JSON.parse(u));
      } catch {}
    }
    setReady(true);
  }, []);

  const setSession = (data) => {
    localStorage.setItem("norea_token", data.access_token);
    localStorage.setItem("norea_user", JSON.stringify(data.user));
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setSession(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("norea_token");
    localStorage.removeItem("norea_user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
